import * as React from 'react';
import { Editor, EditorProps } from 'primereact/editor';
interface EditorComponentProps extends EditorProps{
}

export const EditorComponent: React.FC<EditorComponentProps> = (props) => {
    const header = (
        <div className="row">
            <div className="col-auto">
                <span className="ql-formats">
                    <button className="ql-bold" aria-label="Bold"></button>
                    <button className="ql-italic" aria-label="Italic"></button>
                    <button className="ql-underline" aria-label="Underline"></button>
                    <button type="button" className="ql-list" value="ordered" aria-label="Ordered List"></button>
                    <button type="button" className="ql-list" value="bullet" aria-label="Unordered List"></button>
                    <button type="button" className="ql-image" aria-label="Insert Image"></button>
                </span>
            </div>
        </div>
    );

    return <>
        <Editor
            style={{height: `320px`}}
            {...props}
            className={`pda-editor ${props.className}`}
            headerTemplate={header}
        />
    </>
}
